import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'
import * as icon from "@coreui/icons";

// components
import { CButton } from '@coreui/react-pro'
import AppCard from 'src/components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from '../../components/details/project-details/AppDetails'
import FormFileThumbnail from 'src/components/form/general-input-form/FormFileThumbnail'
import AppTable from 'src/components/AppTable'
import AppModalFilePreview from 'src/components/modal/AppModalFilePreview'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// helpers
import Axios from 'src/helpers/axios'
import { formUrlQuery } from 'src/helpers/format-queries'
import { columnExpenseList, columnInvoiceList, columnSupportingLinksList } from '../../components/table-column/TableColumnList'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ProjectDetails = () => {
  const navigate = useNavigate()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();
  const user = JSON.parse(localStorage.getItem("user"))

  const [projectDetails, setProjectDetails] = useState('')
  const [invoiceDetail, setInvoiceDetail] = useState('')

  const [invoiceListPerPage, setInvoiceListPerPage] = useState(10);
  const [activeInvoiceListPage, setActiveInvoiceListPage] = useState(1);
  const [searchInvoiceListFilter, setSearchInvoiceListFilter] = useState("");
  const [columnInvoiceListSorter, setColumnInvoiceListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [expenseListPerPage, setExpenseListPerPage] = useState(10);
  const [activeExpenseListPage, setActiveExpenseListPage] = useState(1);
  const [searchExpenseListFilter, setSearchExpenseListFilter] = useState("");
  const [columnExpenseListSorter, setColumnExpenseListSorter] = useState({ column: "createdAt", state: "DESC" });

  const [invoiceList, setInvoiceList] = useState([])
  const [expenseList, setExpenseList] = useState([])

  const [openFilePreview, setOpenFilePreview] = useState(false)

  const [showConfirmView, setShowConfirmView] = useState({ show: false, type: '', item: {} })

  const columnInvoiceDetails = columnInvoiceList
  const columnExpenseDetails = columnExpenseList?.filter((col) => col?.key !== 'action')
  const columnSupportingLinkDetails = columnSupportingLinksList?.filter((col) => col?.key !== 'action')

  const handleCardHeaderButton = () => {
    navigate(`/project/edit/${id}`)
  }

  useEffect(() => {
    fetchProjectDetails()
  }, [id]);

  const fetchProjectDetails = () => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/project/${id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setProjectDetails(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  useEffect(() => {
    let queries = {
      search: searchInvoiceListFilter,
      limit: invoiceListPerPage,
      offset: invoiceListPerPage * activeInvoiceListPage - invoiceListPerPage,
      sort:
        (columnInvoiceListSorter &&
          `${columnInvoiceListSorter.column}%${columnInvoiceListSorter.state}`) ||
        "",
      project_id: id
    };
    queries = formUrlQuery(queries);
    fetchAllInvoice(queries)
  }, [
    searchInvoiceListFilter,
    invoiceListPerPage,
    activeInvoiceListPage,
    columnInvoiceListSorter
  ])

  useEffect(() => {
    if (user?.role_id != 1) return; 

    let queries = {
      search: searchExpenseListFilter,
      limit: expenseListPerPage,
      offset: expenseListPerPage * activeExpenseListPage - expenseListPerPage,
      sort:
        (columnExpenseListSorter &&
          `${columnExpenseListSorter.column}%${columnExpenseListSorter.state}`) ||
        "",
      project_id: id
    };
    queries = formUrlQuery(queries);
    fetchAllExpense(queries)
  }, [
    searchExpenseListFilter,
    expenseListPerPage,
    activeExpenseListPage,
    columnExpenseListSorter
  ])

  const fetchAllInvoice = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/invoice?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempInvoiceList = data?.value
          tempInvoiceList = tempInvoiceList?.map((invoice) => ({
            ...invoice,
            client_name: invoice?.client?.name || '-',
            status_invoice: invoice?.is_draft ? 'Draft' : 'Published',
          }))
          setInvoiceList(tempInvoiceList)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const fetchAllExpense = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/expense?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempExpenseList = data?.value || []
          tempExpenseList = tempExpenseList.map((item, index) => {
            return {
              ...item,
              category_name: item?.category?.name || "-",
              project_name: item?.project?.name || "-",
            }
          }) || []
          setExpenseList(tempExpenseList)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleSearchItemsInvoice = (search) => {
    setActiveInvoiceListPage(1)
    setSearchInvoiceListFilter(search);
  }

  const handleSearchItemsExpense = (search) => {
    setActiveExpenseListPage(1)
    setSearchExpenseListFilter(search);
  }

  useEffect(() => {
    if (showConfirmView?.show) {
      if (showConfirmView?.type === 'invoice') {
        let invoiceValue = showConfirmView?.item
        let recipientsValue = invoiceValue?.recipients || []

        if (recipientsValue.length > 0) {
          recipientsValue = recipientsValue?.map((e) => {
            let newValue = {
              ...e,
              phone_number: e?.recipient_contact_number,
              country_id: e?.recipient_country_id,
            }

            if (e?.country_value?.id) {
              newValue.country_value = JSON.stringify({
                id: e?.country_value?.id,
                name: e?.country_value?.name,
                icon: icon[`cif${e?.country_value?.country_code}`],
                phone_code: e?.country_value?.phone_code
              })
            }

            return newValue
          })

          invoiceValue.recipients = recipientsValue
        }

        setInvoiceDetail(invoiceValue)
      }
    }
  }, [showConfirmView])

  const handleOnRowInvoiceClick = (item, columnName) => {
    if (columnName !== 'action') {
      setShowConfirmView({ show: true, type: 'invoice', item })
    }
  }

  return (
    <>
      {openFilePreview && (
        <AppModalFilePreview
          setOpenFilePreview={setOpenFilePreview}
          file={openFilePreview}
        />
      )}
      {
        showConfirmView.show && showConfirmView?.type === 'invoice' && (
          <AppModalConfirmation 
            confirmationType='detail-invoice'
            itemName="detail-invoice"
            itemDetails={invoiceDetail}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      {
        showConfirmView.show && showConfirmView?.type === 'expense' && (
          <AppModalConfirmation 
            confirmationType='detail-expense'
            itemName="detail-expense"
            itemDetails={showConfirmView.item}
            itemType={showConfirmView.type}
            showModal={showConfirmView}
            setShowModal={setShowConfirmView}
            handleViewFile={setOpenFilePreview}
          />
        )
      }
      <div className='d-grid gap-2 d-flex justify-content-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/project/list')}>
          Back
        </CButton>
      </div>
      <AppCard
        className='mt-4 mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Project Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            projectDetails={projectDetails}
            setOpenFilePreview={setOpenFilePreview}
          />
        }
        lowerBodyContent={
          <>
            <AppCard 
              className='mt-4 mb-4'
              headerTitle={<h5>Contracts</h5>}
              bodyContent={
                <>
                  {
                    projectDetails?.contracts?.length > 0 ? (
                      <FormFileThumbnail 
                        name='project_contracts'
                        colSize='4'
                        files={projectDetails?.contracts}
                        className='justify-content-start align-items-center'
                        isDetailPage={true}
                        handleViewFile={setOpenFilePreview}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  }
                </>
              }
            />
            <AppCard 
              className='mt-4 mb-4'
              headerTitle={<h5>Other supporting files</h5>}
              bodyContent={
                <>
                  {
                    projectDetails?.other_supporting_files?.length > 0 ? (
                      <FormFileThumbnail 
                        name='other_supporting_files'
                        colSize='4'
                        files={projectDetails?.other_supporting_files}
                        className='justify-content-start align-items-center'
                        isDetailPage={true}
                        handleViewFile={setOpenFilePreview}
                      />
                    )
                    : (
                      <>Not Found</>
                    )
                  }
                </>
              }
            />
            <AppCard
              className='mt-4 mb-4'
              headerTitle={<h5>Supporting links</h5>}
              bodyContent={
                <AppTable
                  supportingLinksListPage
                  tableColumns={columnSupportingLinkDetails}
                  tableContent={projectDetails?.supporting_links}
                  isShowPagination={false}
                />
              }
            />
            <AppCard 
              className='mt-4 mb-4'
              headerTitle={<h5>Invoices</h5>}
              bodyContent={
                <AppTable
                  invoiceListPage
                  tableFilter
                  tableColumns={columnInvoiceDetails}
                  tableContent={invoiceList}
                  isShowModalEdit={true}
                  isShowDropdownMenu={false}
                  setSearchContentFilter={handleSearchItemsInvoice}
                  setActiveContentPage={setActiveInvoiceListPage}
                  setContentPerPage={setInvoiceListPerPage}
                  setColumnContentSorter={setColumnInvoiceListSorter}
                  handleOnRowClick={handleOnRowInvoiceClick}
                  isClickable={true}
                />
              }
            />
            {
              user?.role_id == 1 && (
                <AppCard 
                  className='mt-4 mb-4'
                  headerTitle={<h5>Expense related to project</h5>}
                  bodyContent={
                    <AppTable
                      expenseListPage
                      tableFilter
                      tableColumns={columnExpenseDetails}
                      tableContent={expenseList}
                      isShowModalEdit={true}
                      isShowDropdownMenu={false}
                      setSearchContentFilter={handleSearchItemsExpense}
                      setActiveContentPage={setActiveExpenseListPage}
                      setContentPerPage={setExpenseListPerPage}
                      setColumnContentSorter={setColumnExpenseListSorter}
                    />
                  }
                />
              )
            }
          </>
        }
      />
    </>
  )
}

export default ProjectDetails
